import { render, staticRenderFns } from "./ParentLearningStories.vue?vue&type=template&id=8cf025f0&"
import script from "./ParentLearningStories.vue?vue&type=script&lang=js&"
export * from "./ParentLearningStories.vue?vue&type=script&lang=js&"
import style0 from "./ParentLearningStories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports